import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  if (!localStorage.getItem("userData")) {
    return (
      <Navigate to={{ pathname: "/sign-in" }} />
    );
  }
  return (
    <React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
